@if (isV2) {
  <div class="page-site-bar" [class.page-site-bar--header]="variant === 'header'">
    <span class="page-site-label">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
        <polyline points="9 22 9 12 15 12 15 22"/>
      </svg>
      {{ 'components.pageSiteSwitcher.label' | translate }}
    </span>
    <app-establishment-switcher
      [establishments]="session.establishments()"
      [selectedId]="session.selectedId()"
      (changed)="onChanged($event)">
    </app-establishment-switcher>
  </div>
}
